import { render } from "./TipList.vue?vue&type=template&id=6e7d0be0&ts=true"
import script from "./TipList.vue?vue&type=script&lang=ts"
export * from "./TipList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__